module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5IIAc"))).then(() => parcelRequire('d0iPb'));